<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SmplAddMain from "@/views/DevelopManagement/SmplManage/TabChild/SmplAddMain";

export default {
  name: "AcctAdd",
  components: {
    childTab1: SmplAddMain,
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>